import ReactGA from 'react-ga';
import Constant from '../common/Constant';

const moment = require('moment');

class Analytics {
  static initialize(config) {
    ReactGA.initialize(config.GA_TRACKING_ID, {
      debug: config.GA_DEBUG,
    });
    ReactGA.pageview(window.location.pathname + window.location.search);

    this.state = {
      day: moment().format(Constant.DATE_FORMAT_SHORT),
    };
  }

  static onLoggedIn(user) {
    if (user.displayName) {
      ReactGA.set({
        userId: user.uid,
        email: user.email,
        name: user.displayName,
      });
    } else {
      ReactGA.set({
        userId: user.uid,
        email: user.email,
      });
    }
  }

  static pageView(page) {
    ReactGA.pageview(page);
  }

  // eslint-disable-next-line no-unused-vars
  static logEvent(event, params) {}
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/analytics/Analytics.js